import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../context/AnalyticsContext';

const AnalyticsTracker = () => {
  const location = useLocation();
  const { trackPageView, storeUTMParams } = useAnalytics();

  useEffect(() => {
    // Store UTM params on route change
    storeUTMParams();
    
    // Track page view
    const pageTitle = document.title;
    trackPageView(location.pathname, pageTitle);
  }, [location, trackPageView, storeUTMParams]);

  return null;
};

export default AnalyticsTracker;
